'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _Dot = require('./Dot.component');

var _Dot2 = _interopRequireDefault(_Dot);

require('../styles/Dots.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dots = function (_BcReactComponent) {
  _inherits(Dots, _BcReactComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, (Dots.__proto__ || Object.getPrototypeOf(Dots)).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems;

      var pages = _lodash2.default.range(0, this.props.pages);

      return _react2.default.createElement(
        'div',
        { className: 'cp-dots' },
        pages.map(function (page) {
          return _react2.default.createElement(_Dot2.default, {
            active: _this2.props.currentPage === page,
            key: page,
            page: page,
            pageSize: pageSize,
            numberOfItems: numberOfItems,
            handleClick: function handleClick() {
              return _this2.props.handleGoToPage(page);
            } });
        })
      );
    }
  }]);

  return Dots;
}(_baseBcReactComponent2.default);

exports.default = Dots;


Dots.propTypes = {
  currentPage: _react.PropTypes.number,
  pages: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number,
  handleGoToPage: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/Dots.component.js
// module id = 1399
// module chunks = 1